// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"XA-z","giftOrPromoSelector":"YA-z","disabled":"ZA-z","subTitle":"_A-z","selectShipAddressMessage":"aB-z","changePayment":"bB-z"};